"use client";

import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const toolkitData = [{
  condition: "Golden Hour",
  camera: "Leica M6",
  lens: "Summicron 35mm f/2",
  film: "Kodak Portra 400",
  notes: "Warm tones, fine grain"
}, {
  condition: "Overcast / Diffused",
  camera: "Hasselblad 500C/M",
  lens: "Zeiss Planar 80mm f/2.8",
  film: "Ilford HP5 Plus",
  notes: "High contrast, rich texture"
}, {
  condition: "Studio / Controlled",
  camera: "Pentax 67",
  lens: "SMC Takumar 105mm f/2.4",
  film: "Kodak Tri-X 400",
  notes: "Classic portrait look"
}, {
  condition: "Night / Low Light",
  camera: "Nikon F3",
  lens: "Nikkor 50mm f/1.2",
  film: "Cinestill 800T",
  notes: "Halation, tungsten balance"
}, {
  condition: "Street / Candid",
  camera: "Leica M6",
  lens: "Elmarit 28mm f/2.8",
  film: "Kodak Gold 200",
  notes: "Vibrant, nostalgic feel"
}];
export default function FeaturedGear() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="featured-gear" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      <div ref={ref} className={cn("max-w-5xl mx-auto transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-serif font-medium tracking-tight mb-4 text-primary">
            The Toolkit
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-sans text-lg font-light">
            A curated selection of analog instruments chosen for their mechanical
            precision and optical character. Each combination is paired with
            specific lighting conditions to achieve the signature FilmFrame
            aesthetic.
          </p>
        </div>

        <div className="border-t border-white/10">
          <Table className="w-full text-left border-collapse">
            <TableHeader>
              <TableRow className="border-b border-white/20 hover:bg-transparent">
                <TableHead className="py-6 text-lg font-serif text-foreground font-normal w-1/4">
                  Lighting Condition
                </TableHead>
                <TableHead className="py-6 text-lg font-serif text-foreground font-normal w-1/4">
                  Camera Body
                </TableHead>
                <TableHead className="py-6 text-lg font-serif text-foreground font-normal w-1/4">
                  Primary Lens
                </TableHead>
                <TableHead className="py-6 text-lg font-serif text-foreground font-normal w-1/4 text-right">
                  Film Stock
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {toolkitData.map((item, i) => <TableRow key={i} data-index={i} className="border-b border-white/10 hover:bg-white/5 transition-colors duration-300 group">
                  <TableCell className="py-6 font-sans text-muted-foreground font-light group-hover:text-foreground transition-colors">
                    {item.condition}
                  </TableCell>
                  <TableCell className="py-6 font-sans text-foreground font-medium">
                    {item.camera}
                  </TableCell>
                  <TableCell className="py-6 font-sans text-muted-foreground group-hover:text-foreground transition-colors">
                    {item.lens}
                  </TableCell>
                  <TableCell className="py-6 font-sans text-primary text-right font-medium tracking-wide">
                    {item.film}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>

        <div className="mt-12 flex justify-between items-center text-sm text-muted-foreground font-mono border-t border-white/10 pt-6">
          <span>* Equipment subject to availability and project requirements.</span>
          <span>Updated: 2024</span>
        </div>
      </div>
    </section>;
}